<template>
  <div class="licoriceLp__base">
    <div class="licoriceLp__topviusal" :class="{subsc: isSubsc}">
      <img v-if="isThresholdReached" src="/static/img/licorice/lp/licoLp_topvisual_noprice.png" alt="Licorice 読む人の背中をそっと押す不思議な物語を売る書店"/>
      <img v-else src="/static/img/licorice/lp/licoLp_topvisual_free.png" alt="Licorice 読む人の背中をそっと押す不思議な物語を売る書店"/>
      <span v-if="!isSubsc" class="toQuestionBtn" @click="onToQuestionBtnClick">あなたの物語を買う</span>
    </div>
    <div class="licoriceLp__intro">
      <div class="wrap">
        <div class="intro-message">
          <img src="/static/img/licorice/lp/licoLp_introduction_title.png">
          <span class="mess">今日も、あの人から<br>言葉を買いに</span>
          <span class="wordsBy">by カツセマサヒコ</span>
        </div>
        <div class="description">
          <p>「占いって、“言葉”を買いにいく場所なんですよね」</p>
          <p>作業中にラジオを聴いていたら、パーソナリティの女性がさりげなく言った。ゲストの声にかき消されるかと思うほど弱々しい一言だったけれど、声の大きさではなく言葉の強さに惹かれて、小さなボリュームで流れていたラジオに耳を傾けた。</p>
          <p>言葉はいろんなところに存在していて、たとえば今こうして読んでもらえている文章にも、ショボいながらにたくさんの言葉が使われている。でもそれを「買いにいく」なんて発想をしたことはおそらく人生で一度もなかった。</p>
          <p>本屋に行っても、買いに行くのは「本」自体、もしくはそこから得られる「知識」や「まだ出会ったことのない感情」、「想像力」等といったものであり、トークイベントも同様に「話し手との空間の共有」だったり「ライヴならではの臨場感」を求めて足を運ぶわけだから、おそらく「言葉」自体にフォーカスしたことはない。</p>
          <p>「あの人から、言葉を買いに」</p>
          <p>八百屋で野菜を買うように、パン屋でパンを買うように、占い師から、言葉を買いにいく。そう考えると、「占い」は信じる・信じないではなく、自分専用の言葉を売ってくれる場所であり、人なのだと、気付かされる。</p>
          <p>そんなことをラジオの感想としてツイートしたところ、占い師の鏡リュウジさんが反応してくださって、「何か一緒にやりませんか」と動き出したのが、つい数ヶ月ほど前のことだった。</p>
          <p>僕はそれまで「星座占いは上位のときだけ信じればいい」ぐらいに思っていたもので、たとえば12位であったなら見なかったことにしていたし、仮に1位をとったのに嫌なことが続いたなら「これで1位じゃなかったら、今頃死んでいたかもしれない」と無駄にポジティヴな発想で乗り越えていたものだから、「占い」というものにきちんと向き合う機会はほとんどなかった。</p>
          <p>とはいえ、「何かを書く」という仕事をしていると、そこに読者が集まって、時には大小問わずさまざまな悩みや不安、不満を聞かせてくれることがある。そうすると、僕は占い師でもないのに「言葉」を探して、どうにか届けようとするものだから、いつも中途半端な感覚が残って終わっていた。</p>
          <p>もう少し、上手に背中を押してあげられたら。</p>
          <p>そんなぼんやりとした小さな願望を、今回、鏡さんという大きな助っ人の力をお借りして、叶えることができたように思う。つまり、鏡さんが導いた占星術の結果をもとに、僕が48のちいさな物語を書いた。</p>
          <p>悩みや迷いの声の多くは女性から寄せられていたから、基本的には、48の物語の主人公は、すべて女性だ。でも、性別に捉われる必要はないとも思う。少しでも「あ、自分もこの主人公とおんなじだ」と共感し、そこから一歩踏み出す助けになっていたらうれしい。</p>
          <p>最後にちょっとした感想ですが、執筆中に何度も思ったのは、自分を救ってくれるのは、最終的には自分しかしない、ということだった。物語の途中、いろんなキャラクターがヒントを出してはくれるものの、自分だけの答えを選ぶのは、いつだって主人公ひとりだ。それは人生にも同じことが言えるように思う。</p>
          <p>今日も、信じる・信じないではなく、あなただけの言葉を買いに、訪れてもらえたら嬉しいです。</p>
        </div>
        <span :class="`ctrl-btn${isDescOpen ? ' open' : ''}`" @click="onDescOpenClick">{{ descCtrlBtnFace }}</span>
      </div>
    </div>

    <div class="licoriceLp__contEntrance">
      <img src="/static/img/licorice/lp/licoLp_logoKanban.png">
      <p>街の片隅にひっそりと佇む小さな本屋 リコリス。<br>店主の名前は月城尚也。<br>彼が選ぶ物語を読むと、<br>心にかかった雲が晴れるという。</p>
      <video :src="sampleVideoUrl" poster="/static/img/licorice/lp/poster_samplemovie.png" playsinline muted preload="auto"></video>
    </div>

    <div class="licoriceLp__contTsukiMess">
      <div class="wrap">
        <img src="/static/img/licorice/lp/licoLp_face_tsukishiro.png">
        <p>いらっしゃいませ、リコリスへようこそ。<br>店主の月城と申します。</p>
        <p>当店では、読む人と同じ生年月日の<br>主人公が登場する、<br>ちょっと不思議な本を<br>取り扱っております。</p>
        <p>本を選ぶのは、私にお任せください。<br>お客様に合わせて、<br>おすすめの本を3冊選ばせていただきます。</p>
        <p>それでは、本を選んでゆきましょう。</p>
      </div>
    </div>

    <div v-if="isEnableBuy" id="selectbooks" class="licoriceLp__contSelectBooks">
      <div class="message">２つ、３つの簡単な質問にお答えください。</div>
      <div class="question-frame"></div>
      <lp-licorice-question :is-threshold-reached="isThresholdReached"></lp-licorice-question>
    </div>
    <!-- <scroll-top class="scrollToTopBtn" ></scroll-top> -->
  </div>
</template>

<script>
import LpLicoriceQuestion from "./LpLicoriceQuestion";
export default {
  name: "LpLicorice",
  components: { LpLicoriceQuestion },
  data (){
    return {
      sampleVideoUrl: `${this.awsPrefix}/lp/video_letter/fast/licorice.mp4`,
      isSampleVidIn: false,
      isSampleVidPlaying: false,
      scrollLock: false,
      sampleVidPlayCnt: 0,
      isDescOpen: false,
      descHeight: 0,
      descOpenCnt: 0,
      elm: {
        description: null,
        descCtrlBtn: null,
        sampleVid: null
      }
    }
  },
  props: {
    awsPrefix: {
      type: String,
      default() {
        return ''
      }
    },
    nowOrderCount: {
      type: String,
      default() {
        return ''
      }
    },
    userProfile: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  computed: {
    isSubsc() {
      return true
    },
    isEnableBuy(){
      //一旦サブスク以外は無視
      if(!!this.userProfile && !!this.userProfile.subscription) {
        const subsc = this.userProfile.subscription
        const stat =parseInt(subsc.status)
        if(parseInt(subsc.active) === 1
          && (stat > 0 && stat !== 2 && stat !== 4)
          && parseInt(subsc.free_buy) > 0
        ){
          return true
        }
      }
      return false
    },
    isThresholdReached () {
      // const cnt = parseInt(this.nowOrderCount)
      // const res = cnt >= 500
      // return res
      return true
    },
    descCtrlBtnFace () {
      return this.isDescOpen ? '閉じる' : '続きを読む'
    }
  },
  mounted () {
    const _this = this
    this.elm.description = this.$el.querySelector('.licoriceLp__intro .description')
    this.descHeight = this.elm.description.clientHeight
    this.elm.description.classList.add('shortview')
    this.elm.sampleVid = this.$el.querySelector('.licoriceLp__contEntrance video')
    this.elm.sampleVid.addEventListener('ended', () => {
      _this.elm.sampleVid.currentTime = 0
      if(_this.isSampleVidIn){
        _this.sampleVidPlayCnt++
        let tgtlabel = _this.sampleVidPlayCnt === 2 ? 'lp_intro_video_first_finish' : 'lp_intro_video_loop'
        window.gtag('event', 'moviePlay', {'event_category': 'Licorice_LP', 'event_label': tgtlabel, 'value': this.sampleVidPlayCnt })
      }
      _this.elm.sampleVid.play()
    })

    window.addEventListener('scroll', () => {
      const rect  = this.elm.sampleVid.getBoundingClientRect()
      const tgtpos = rect.top + window.scrollY
      if(tgtpos < (window.scrollY + window.innerHeight) &&  window.scrollY <= (tgtpos + rect.height) ){
        this.isSampleVidIn = true
        if(!this.isSampleVidPlaying && !this.scrollLock) {
          this.isSampleVidPlaying = true
          setTimeout( () => {
            _this.sampleVidPlayCnt++

            window.gtag('event', 'moviePlay', {'event_category': 'Licorice_LP', 'event_label': 'lp_intro_video_first_play', 'value': this.sampleVidPlayCnt })
            _this.elm.sampleVid.play()
          },1000)
        }
      }else{
        this.isSampleVidIn = false
      }
    })
  },
  methods: {
    onToQuestionBtnClick () {
      const tgt = document.getElementById('selectbooks').getBoundingClientRect()
      const tgtpos = window.pageYOffset + tgt.y - 32
      const _this = this
      window.gtag('event', 'click', {'event_category': 'Licorice_LP', 'event_label': 'lp_top_buy', 'value': 1 })
      this.scrollLock = true
      $('html,body').animate({scrollTop: tgtpos}, {
        complete () {
          _this.scrollLock = false
        }
      })
    },
    onDescOpenClick () {
      if(this.isDescOpen) {
        this.isDescOpen = false
        this.elm.description.style.height = `300px`
        this.elm.description.classList.add('shortview')
        this.elm.description.classList.remove('open')
      } else {
        this.isDescOpen = true
        this.elm.description.style.height = `${this.descHeight}px`
        this.elm.description.classList.remove('shortview')
        this.elm.description.classList.add('open')
        this.descOpenCnt++
        window.gtag('event', 'click', {'event_category': 'Licorice_LP', 'event_label': 'lp_essay_more', 'value': this.descOpenCnt })
      }
    }
  }
}</script>

<style lang="scss" scoped>
@import "../../../../../sass/variables/index";
.licoriceLp {
  $baseMargin: 16px;
  &__base {
    width: 100%;
    max-width: $container-width;
    margin: 0 auto;
    font-family: $font_mincho
  }
  &__topviusal {
    width: 100%;
    position: relative;
    img {
      width: 100%;
      display: block;

    }
    a, .toQuestionBtn {
      display: block;
      width: calc(100% - (16px * 2));
      margin: auto;
      position: absolute;
      bottom: 32px;
      right: 0;
      left: 0;
      background: $brown-1;
      color: white;
      font-weight: bold;
      font-size: 16px;
      line-height: 1;
      padding: 16px;
      letter-spacing: 1px;
      text-align: center;
      border-radius: 4px;
      text-decoration: none;
      font-family: $font_gothic;
    }
  }
  &__intro {
    $animSpd: 500ms;
    width: 100%;
    background: url('/static/img/licorice/lp/licoLp_introduction_bg.png') no-repeat top center $brown-3;
    background-size: 100% auto;
    padding: 53vw 16px 16px;
    position: relative;
    @include mq () {
      padding: 300px 16px 16px;
    }
    .wrap {
      width: 100%;
      padding: 26px;
      background: $brown-2;
      border-radius: 10px;
      @include mq () {
        padding: 26px 38px 36px;
      }

      .intro-message {
        width: 100%;
        text-align: center;
        position: absolute;
        height: 53vw;
        top: 32px;
        left: 0;
        right: 0;
        margin: auto;
        img {
          width: 100%;
          display: block;
          margin-bottom: 18px;
          @include mq () {
            margin-bottom: 38px;
          }
        }
        .mess {
          display: block;
          width: 100%;
          font-size: 20px;
          line-height: 30px;
          font-weight: 600;
          letter-spacing: 3px;
          color: $white;
          margin-bottom: 12px;
          @include mq () {
            font-size: 24px;
            line-height: 38px;
            margin-bottom: 18px;
          }
        }
        .wordsBy {
          display: block;
          width: 100%;
          font-size: 14px;
          font-weight: 600;
          line-height: 1;
          color: $white;
          @include mq () {
            font-size: 16px;
          }
        }
      }
      .description {
        width: 100%;
        color: $white;
        font-weight: 600;
        font-size: 14px;
        line-height: 28px;
        letter-spacing: 1px;
        opacity: 0;
        transition: all $animSpd ease 0s;
        margin-bottom: 24px;
        overflow: hidden;
        position: relative;

        @include mq () {
          font-size: 15px;
          line-height: 30px;
        }

        &::after {
          content: '';
          width: 100%;
          height: 100px;
          background: linear-gradient(to bottom, rgba(74,49,38,0) 0%,rgba(74,49,38,0.99) 86%,rgba(74,49,38,1) 87%);
          z-index: 10;
          position: absolute;
          bottom: 0;
          left: 0;
          opacity: 1;
          transition: opacity $animSpd ease 0s;
        }
        &.shortview {
          opacity: 1;
          height: 300px;
        }
        &.open {
          opacity: 1;
          &::after {
            opacity: 0;
          }
        }
      }
      .ctrl-btn {
        width: 100%;
        display: block;
        color: $white;
        font-size: 14px;
        line-height: 1;
        letter-spacing: 1px;
        padding: 10px;
        border-radius: 4px;
        border: 1px solid $white;
        background: $brown-2;
        text-align: center;
        cursor: pointer;
        position: relative;
        font-family: $font_gothic;
        @include mq () {
          padding: 16px;
        }
        &::after {
          content: '';
          width: 18px;
          height: 18px;
          background: url('/static/img/licorice/lp/ic_arrow_down.svg') no-repeat center center;
          background-size: 100% 100%;
          position: absolute;
          top: 0;
          bottom: 0;
          right: 20px;
          margin: auto;
          transform-origin: 50%;
          transition: transform $animSpd ease-out 0s;
        }
        &.open {
          &::after {
            transform: rotate(180deg);
          }
        }
      }
    }
  }
  &__contEntrance {
    width: 100%;
    background: $gray-12;
    padding: 40px 0 0;
    img {
      width: 100%;
    }
    p {
      color: $brown-4;
      width: 100%;
      font-weight: 600;
      font-size: 12px;
      line-height: 24px;
      text-align: center;
      margin: 18px 0 30px;
      @include mq ('w320') {
        font-size: 14px;
        line-height: 28px;
        margin: 24px 0 36px;
      }
      @include mq () {
        font-size: 18px;
        line-height: 44px;
        margin: 36px 0 60px;
      }
    }
    video {
      border: 1px solid $gray-9;
      margin: 0 auto;
      display: block;
      width: 240px;
      border-radius: 10px;
      @include mq () {
        width: 300px;
      }
    }
  }
  &__contTsukiMess {
    width: 100%;
    text-align: center;
    background: $gray-12;
    padding: 32px 16px 72px;
    @include mq ('w320') {
      padding: 32px 22px 72px;
    }
    @include mq () {
      padding: 60px 16px 72px;
    }
    .wrap {
      //エラー対策でショートハンドは使わない(2019/08/20)
      $revRoundRadius: 9px;
      background-color: $gray-13;
      background-size: $revRoundRadius * 2;
      background-image:
        url('/static/img/licorice/lp/corner_revround.svg'),
        url('/static/img/licorice/lp/corner_revround.svg'),
        url('/static/img/licorice/lp/corner_revround.svg'),
        url('/static/img/licorice/lp/corner_revround.svg');
      background-position:
        left (-$revRoundRadius) top (-$revRoundRadius),
        right (-$revRoundRadius) top (-$revRoundRadius),
        left (-$revRoundRadius) bottom (-$revRoundRadius),
        right (-$revRoundRadius) bottom (-$revRoundRadius);
      background-repeat: no-repeat, no-repeat, no-repeat, no-repeat;

      padding: 32px 0 24px;
      @include mq () {
        padding: 48px 0 36px;
      }

      img {
        width: 112px;
        margin-bottom: 12px;
        @include mq () {
          width: 144px;
        }
      }

      p {
        color: $brown-5;
        font-weight: 600;
        font-size: 13px;
        line-height: 24px;
        @include mq () {
          font-size: 16px;
          line-height: 32px;
        }
      }
    }
  }
  &__contSelectBooks {
    width: 100%;
    padding: 62px 16px 56px;
    background: $gray-12;
    background: url('/static/img/licorice/lp/licoLp_selectbook_title.png') no-repeat center top $gray-12;
    background-size: 100% auto;
    @include mq('w320') {
      padding: 62px 28px 56px;
    }

    .message {
      width: 100%;
      text-align: center;
      font-size: 14px;
      line-height: 28px;
      color: $brown-4;
      margin-bottom: 24px;
    }
  }
}
.scrollToTopBtn {
  position: fixed;
  bottom: 16px;
  right: 10px;
}

.licoriceLp__topviusal {
  &.subsc {
    position: relative;
    overflow: hidden;
    &::before {
      content:"";
      display: block;
      padding-top: 76%;
    }
    img {
      position: absolute;
      top: -1rem;
      left: 0;
    }
  }
}

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/lp/licorice/LpLicorice.vue